import { render } from "./uploadxls2.vue?vue&type=template&id=f0305cb2&scoped=true"
import script from "./uploadxls2.vue?vue&type=script&lang=js"
export * from "./uploadxls2.vue?vue&type=script&lang=js"

import "./uploadxls2.vue?vue&type=style&index=0&id=f0305cb2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0305cb2"]])

export default __exports__